// 内容管理
export default [
  {
    path: "/contents",
    meta: { title: "内容管理" },
    component: () => import("../views/contents/index"),
    children: [
      {
        path: "/contents/carousel",
        name: "contentsCarousel",
        meta: { title: "轮播图管理", isMenu: true },
        component: () => import("../views/contents/carousel"),
      },
      {
        path: "/contents/message",
        name: "contentsMessage",
        meta: { title: "平台消息", isMenu: true },
        component: () => import("../views/contents/message"),
      },
      {
        path: "/contents/message/detail/messageDetail",
        name: "contentsMessageDetail",
        meta: { title: "消息详情" },
        component: () => import("../views/contents/detail/messageDetail"),
      },
    ],
  },
]
